import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
import LottieObject from "@/components/general/LottieObject.vue"

const MINIMUM_LOADING_DURATION = 3000;
const FADE_OUT_DURATION = 500;


export default /*@__PURE__*/_defineComponent({
  __name: 'CurtainAnimation',
  emits: ['curtain-closed'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const showCurtain = ref(true);
const isPageLoaded = ref(false);
const isRevealing = ref(false);
const minTimeElapsed = ref(false);

function tryStartReveal() {
    if (isPageLoaded.value && minTimeElapsed.value) {
        startRevealAnimation();
    }
}

function startRevealAnimation() {
    isRevealing.value = true;
}

function onAnimationComplete() {
    isRevealing.value = false;

    setTimeout(() => {
        showCurtain.value = false;
        emit('curtain-closed');
    }, FADE_OUT_DURATION);
}

onMounted(() => {
    setTimeout(() => {
        minTimeElapsed.value = true;
        tryStartReveal();
    }, MINIMUM_LOADING_DURATION);

    if (document.readyState === 'complete') {
        isPageLoaded.value = true;
        tryStartReveal();
    } else {
        window.addEventListener('load', () => {
            isPageLoaded.value = true;
            tryStartReveal();
        }, { once: true });
    }
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['curtain-overlay', { 'is-hidden': !isRevealing.value && !showCurtain.value }])
  }, [
    (!isRevealing.value)
      ? (_openBlock(), _createBlock(LottieObject, {
          key: 0,
          jsonFile: "site-loading_2-light.json",
          loop: true,
          autoPlay: true,
          speed: 1
        }))
      : _createCommentVNode("", true),
    (isRevealing.value)
      ? (_openBlock(), _createBlock(LottieObject, {
          key: 1,
          jsonFile: "site-reveal_3-light.json",
          loop: false,
          autoPlay: true,
          speed: 1,
          onOnComplete: onAnimationComplete
        }))
      : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, showCurtain.value]
  ])
}
}

})